import { AlertTitle, Alert as MuiAlert } from '@mui/material';
import React from 'react';

const Alert = (props) => {
  const { title, message, severity, className } = props || {};

  return (
    <MuiAlert severity={severity} className={`w-90 mt-3 ${className}`}>
      {!!title && <AlertTitle>{title}</AlertTitle>}
      {message}
    </MuiAlert>
  );
};

export default Alert;
